module.exports = __webpack_public_path__ + "img/pencil.ca416fb5.png";